import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { AppActions, AppActionTypes } from './actions';
import { PhosphateLegalWorkingCoefficient, PhosphateLegalWorkingCoefficientsState } from '../shared/models';

export const phosphateLegalWorkingCoefficientsAdapter: EntityAdapter<PhosphateLegalWorkingCoefficient> =
  createEntityAdapter<PhosphateLegalWorkingCoefficient>();
export const initialPhosphateLegalWorkingCoefficientsState: PhosphateLegalWorkingCoefficientsState = phosphateLegalWorkingCoefficientsAdapter.getInitialState(
  {},
);

export function phosphateLegalWorkingCoefficientsReducer(
  state = initialPhosphateLegalWorkingCoefficientsState,
  action: AppActions,
): PhosphateLegalWorkingCoefficientsState {
  switch (action.type) {
    case AppActionTypes.LoadPhosphateLegalWorkingCoefficientsSuccess: {
      const removedState = phosphateLegalWorkingCoefficientsAdapter.removeAll(state);
      return phosphateLegalWorkingCoefficientsAdapter.upsertMany(action.phosphateLegalWorkingCoefficients, removedState);
    }

    case AppActionTypes.UpsertPhosphateLegalWorkingCoefficientSuccess: {
      return phosphateLegalWorkingCoefficientsAdapter.upsertOne(action.phosphateLegalWorkingCoefficient, state);
    }

    case AppActionTypes.DeletePhosphateLegalWorkingCoefficientSuccess: {
      return phosphateLegalWorkingCoefficientsAdapter.removeOne(action.phosphateLegalWorkingCoefficient.id, state);
    }

    default: {
      return state;
    }
  }
}
